<script setup>
import {Delete, Plus,Edit} from '@element-plus/icons-vue';
import {Cropper} from "vue-advanced-cropper";
import imageCompression from "browser-image-compression";
import axios from "axios";
import {onMounted, ref} from "vue";
import Cookies from "js-cookie";
let uploadProgress = ref(0);

const props = defineProps(['DataId','Section','IsVideo','IsImage', 'IsMultid']);
const IsMulti = ref(true);
console.log(props.IsMultid)
if( props.IsMultid === undefined||props.IsMultid ===''){

  IsMulti.value=true;
}else{
  IsMulti.value=props.IsMultid
}

const isImage = ref(props.IsImage);
const thumbnail =ref(ref);
const uploader=ref(null);
const cropperRef=ref(null);
const video =ref(null);
const cropping=ref(false);
const img =ref(null);
const isWorking=ref(false);
const allMedia =ref([]);
const emit = defineEmits(['urlEvent']);
function sendUpdate(payload) {
  emit('urlEvent', payload);
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const url = ref('');
const srcList = ref([
])
onMounted(async()=>{
  const response = await fetch('https://inv.tvcnews.co/endPoint/GetMedia.php',{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '+Cookies.get('user_token')
    },
    body:JSON.stringify({
      DataId:props.DataId,
      Section:props.Section
    })
  })
  const data = await response.json();
  srcList.value= data?.images?.urls;
  url.value=data?.images?.urls[0];
  allMedia.value= data;
  console.log(allMedia.value)
})
async function changeThumbnail(e){
  const file = e.target.files[0];
  const options = {
    maxSizeMB: 0.6,
    maxWidthOrHeight: 1000,
    useWebWorker: false,
  }
  const compressedFile = await imageCompression(file, options);
  const newFile = new File([compressedFile], file.name, { type: compressedFile.type, lastModified: new Date() });
  const formData = new FormData()
  formData.append("file", newFile);
  if(!allMedia.value?.videos?.data[0]?.Id){
    return
  }
  formData.append("mediaId", allMedia.value?.videos?.data[0]?.Id);
  formData.append("DataId", props.DataId);
  formData.append("Section", props.Section);
  axios.post('https://inv.tvcnews.co/endPoint/updateThumbnail.php', formData)
      .then(res => {
        if(res.status===200){
          allMedia.value.videos.data[0].Thumbline=res.data?.thumbnailUrl;
        }
      })
}
async function deleteMedia(Id,urlthis){
  const response = await fetch('https://inv.tvcnews.co/endPoint/dMedia.php',{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '+Cookies.get('user_token')
    },
    body:JSON.stringify({
      Id:Id
    })
  })
  const data = await response.json();
  if(data?.status===200){
    let index = srcList.value.findIndex(item=>item===urlthis);
    srcList.value.splice(index,1);
    let index1 = allMedia.value?.images?.data.findIndex(item=>item.Id== Id);
    allMedia.value?.images?.data.splice(index1,1);
    if(urlthis===url.value){
      url.value=srcList.value[0];
    }
  }else{
    console.error(data?.message)
  }
}
async function deleteMedia2(Id,urlthis){
  const response = await fetch('https://inv.tvcnews.co/endPoint/dMedia.php',{
    method:"POST",
    headers:{
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization':'Bearer '+Cookies.get('user_token')
    },
    body:JSON.stringify({
      Id:Id
    })
  })
  const data = await response.json();
  if(data?.status===200){
    let index = srcList.value.findIndex(item=>item===urlthis);
    srcList.value.splice(index,1);
    let index1 = allMedia.value?.videos?.data.findIndex(item=>item.Id== Id);
    allMedia.value?.videos?.data.splice(index1,1);
  }
}
const uploadVideo = async (file) => {
  const formData = new FormData();
  formData.append('file' , file);
  formData.append('DataId',props.DataId );
  formData.append('section',props.Section );
  const response = await axios.post('https://inv.tvcnews.co/endPoint/UploadVideo2.php', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization':'Bearer '+Cookies.get('user_token')
    },
    onUploadProgress: (progressEvent) => {
      uploadProgress.value = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      if(uploadProgress.value>99){
        setTimeout(()=>{
          uploadProgress.value=0;
        },2000)
      }
    }
  });
  if(response.status===200){
    allMedia.value?.videos?.data?.unshift(response?.data?.mediaData);
    video.value.value=null
  }else{
    video.value.value=null

  }
};
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function close(){
  cropping.value=false;
  uploader.value.value=null;
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function capture(){
  uploader.value.click()
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function selectImg(newUrl){
  url.value=newUrl;
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function changeVideo(e){
  const file = e.target.files[0];
  await uploadVideo(file)
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function capture2(){
  video.value.click();
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function capture3(){
  thumbnail.value.click();
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
async function uploadImg(){
  cropping.value=false;
  isWorking.value=true;
  const cropper = cropperRef.value;
  let file;
  if (cropper) {
    const canvas = cropper.getCanvas(); // Get cropped image as canvas
    const blob = await new Promise(resolve => canvas.toBlob(resolve));
    file =new File([blob], 'cropedPhoto.png', { type: blob.type, lastModified: new Date() });

  }else{
    return
  }
  const options = {
    maxSizeMB: 0.6,
    maxWidthOrHeight: 1000,
    useWebWorker: false,
  }
  const compressedFile = await imageCompression(file, options);
  const newFile = new File([compressedFile], file.name, { type: compressedFile.type, lastModified: new Date() });
  let formData = new FormData();
  if(newFile){
    formData.append('file',newFile );
    formData.append('DataId',props.DataId );
    formData.append('section',props.Section );
    const response = await fetch('https://inv.tvcnews.co/endPoint/UploadImg2.php',{
      method:"POST",
      body:formData
    })
    const data = await response.json();
    if(data?.mediaData?.Id>0){
      srcList.value.push(data?.fileUrl);
      url.value=data?.fileUrl;

      sendUpdate(url.value)
      allMedia.value.images.data.push(data?.mediaData);
      // allMedia.value.images.urls.push(data?.mediaData?.Url)

    }
    isWorking.value=false;
    uploader.value.value=null;
  }
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

async function changeFile(e){
  const file = e.target.files[0];
  img.value = URL.createObjectURL(file);
  cropping.value=true
}

</script>

<template>
  <input hidden type="file" ref="uploader"  accept="image/*" @change="changeFile">
  <input hidden type="file" ref="thumbnail"  accept="image/*" @change="changeThumbnail">
  <input hidden type="file" ref="video"  accept="video/*" @change="changeVideo">
  <div class="cropperModal" style="width: 100%;height: 100vh;position: fixed;top: 0;left: 0;background-color: white;z-index: 20000;overflow-x:hidden;overflow-y: auto" v-if="cropping">
    <div style="text-align: center;margin-top: 10px;position: fixed;top:5px;left:0;z-index: 20001">
      <el-button type="info" @click="close">Close</el-button>
      <el-button type="success" @click="uploadImg">Crop & Process</el-button>
    </div>
    <Cropper
        ref="cropperRef"
        :src="img"
        style="margin-top: auto;margin-bottom: auto"
    />
  </div>
  <div class="main" v-if="props.DataId && props.Section">
    <el-switch
        v-model="isImage"
        class="mb-2"
        active-text="Images"
        inactive-text="Video"
        v-if="props.IsVideo && props.IsImage"
    />
    <div style="text-align: center;margin-bottom: 5px" v-if="isImage">
    </div>
    <el-image
        v-loading="isWorking"
        v-if="isImage && srcList?.length>0"
        style="height: 300px;border-radius: 10px"
        :src="url"
        :zoom-rate="1.2"
        :preview-src-list="srcList"
        :initial-index="srcList?.length"
        fit="cover"
    />
    <div class="gallery" v-if="isImage">
      <div
          :key="item?.Id"
          @click="selectImg(item?.Url)"
          v-for="item in allMedia?.images?.data"
          class="gItem" :class="item?.Url===url?'active':''"
          :style="'background-image: url('+item?.Url+')'"
      >
        <Delete @click="deleteMedia(item?.Id,item?.Url)" class="del"/>
      </div>
      <div v-if="IsMulti || !IsMulti && allMedia?.images?.data?.length===0" @click="capture" v-loading="isWorking"  class="gItemPlus" ><Plus class="plus"/> </div>
    </div>
    <div v-if="!isImage && props.IsVideo" style="text-align: left">
      <div>
        <div  style="text-align: center;margin-bottom: 5px">
          <el-button round @click="capture2">Upload the Video</el-button>
          <el-button round @click="capture3" v-if="allMedia?.videos?.data[0]?.Id">Upload the Thumbnail</el-button>
        </div>

        <div class="thumb">
          <img :key="allMedia?.videos?.data[0]?.Thumbline" :src="allMedia?.videos?.data[0]?.Thumbline" style="height: 100px;border-radius: 5px">

        </div>
        <div class="thumb" v-if="allMedia?.videos?.data[0]?.Url">
          <video :key="allMedia?.videos?.data[0]?.Url" controls :src="allMedia?.videos?.data[0]?.Url" :poster="allMedia?.videos?.data[0]?.Thumbline" style="height: 150px;border-radius: 10px"></video>
          <el-button type="danger" :icon="Delete" circle @click="deleteMedia2(allMedia?.videos?.data[0]?.Id,allMedia?.videos?.data[0]?.Url)" />
        </div>
        <el-progress
            v-if="uploadProgress>0"
            :text-inside="true"
            :stroke-width="24"
            :percentage="uploadProgress"
            status="success"
        />
      </div>

    </div>
  </div>


</template>

<style scoped>

.main{
  background-color: white;
  padding: 10px;
}
.active{
  border: solid 3px #096ed7;
}
.del{
  width: 20px;
  color: white;
}

.del:hover{
  color: red;
}
.plus{
  width: 28px;
  color: #a4a4a4;
}

.plus:hover{
  color: #0078ff;
}
.gallery{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.gItemPlus{
  width: 100px;
  height: 100px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin: 2px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 2px;
  border: solid 2px #dadada;
}
.gItemPlus:hover{
  border-color: #0078ff;
  background-color: #add5ff;
}
.gItem{
  width: 100px;
  height: 100px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin: 2px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: flex-end;
  cursor: pointer;
  border-radius: 2px;
}
.thumb{
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  flex-wrap: nowrap;
  align-items: center;
}
</style>